import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NewsDetail = () => {
  const { id } = useParams();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Article {id}
          </h1>
          <p className="text-xl text-gray-600">
            Cette page sera bientôt disponible.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsDetail;

